// Vue & Plugins
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import {
  plural as pluralizePlural,
  singular as pluralizeSingular,
} from 'pluralize'

import { useAuthSiteStore } from '../../user/authSiteStore'

export type ResourceTerm =
  | 'areas'
  | 'buildings'
  | 'employees'
  | 'skills'
  | 'skill_types'

export const ResourceKeys = {
  EMPLOYEE: 'employees',

  AVAILABILITY: 'availability',

  AREA: 'areas',
  BUILDING: 'buildings',

  SKILL: 'skills',
  SKILL_TYPE: 'skill_types',
}

export function useResourceNames() {
  const authSiteStore = useAuthSiteStore()
  const { terms } = storeToRefs(authSiteStore)
  const getTerm = (key: string) =>
    computed(() => {
      const termKey = key.toLowerCase()

      return !terms.value
        ? termKey
        : (terms.value[termKey] ?? termKey.replace(/_/g, ' '))
    })
  const getSingular = (key: string) =>
    computed(() => {
      const termKey = key.toLowerCase()
      return pluralizeSingular(
        !terms.value
          ? termKey
          : (terms.value[termKey] ?? termKey.replace(/_/g, ' ')),
      )
    })
  const getPlural = (key: string) =>
    computed(() => {
      const termKey = key.toLowerCase()
      return pluralizePlural(
        !terms.value
          ? termKey
          : (terms.value[termKey] ?? termKey.replace(/_/g, ' ')),
      )
    })

  return {
    getTerm,
    getSingular,
    getPlural,
  }
}

export function useResourceLabel(resourceTerm: ResourceTerm) {
  const authSiteStore = useAuthSiteStore()
  const { terms } = storeToRefs(authSiteStore)

  const term = computed(() =>
    !terms.value
      ? resourceTerm
      : (terms.value[resourceTerm] ?? resourceTerm.replace(/_/g, ' ')),
  )
  const singular = computed(() =>
    pluralizeSingular(
      !terms.value
        ? resourceTerm
        : (terms.value[resourceTerm] ?? resourceTerm.replace(/_/g, ' ')),
    ),
  )
  const plural = computed(() =>
    pluralizePlural(
      !terms.value
        ? resourceTerm
        : (terms.value[resourceTerm] ?? resourceTerm.replace(/_/g, ' ')),
    ),
  )

  return {
    term,
    singular,
    plural,
  }
}
